import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import { MCText, SearchTextField, Spinner, View } from 'src/components/basic';
import { remCss, remFontCss } from 'src/components/mobile/utils';
import ShortInfo from 'src/components/user/ShortInfo';
import { ActivityLabel } from 'src/components/user/LastActivity';

import { lang, userFullName } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

import managersModel from '../managersModel';
import { HeaderBack } from 'src/components/mobile/HeaderBack';

const Item = ({ item, onManagerItem }) => {
  return (
    <View
      style={{
        backgroundColor: 'white',
        paddingVertical: remCss(15),
        paddingHorizontal: remCss(20),
        flexDirection: 'row',
        gap: remCss(10),
        alignItems: 'center',
        cursor: 'pointer'
      }}
      onClick={() => {
        onManagerItem(item);
      }}
    >
      <ShortInfo
        user={item}
        fullname={userFullName(item, item.isDoctor)}
        width={remCss(60)}
        onlineState={item.connections > 0 ? 'online' : ''}
        note={
          <MCText size={18} remFontCss={remFontCss} numberOfLines={1} weight={400} primary>
            <ActivityLabel
              accountState={item.accountState}
              lastActivity={item.lastActivity}
              connections={item.connections}
            />
          </MCText>
        }
      />
    </View>
  );
};

export const Managers = ({ onManagerItem, onBack }) => {
  const [searching, setSearching] = React.useState(false);
  managersModel.use();

  const items = managersModel.items();
  const loading = managersModel.refreshing();
  const searchQuery = managersModel.listInput('search');
  const noResults = managersModel.noResults();

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: 'white'
      }}
    >
      <HeaderBack onBack={onBack} title={'Managers'} />
      <Virtuoso
        data={items}
        style={{ backgroundColor: 'white' }}
        components={{
          Header: () => (
            <View style={{ padding: remCss(15) }}>
              <SearchTextField
                template={'2'}
                placeholder={'Search'}
                autoFocus={searching}
                onChange={(v) => {
                  setSearching(true);

                  managersModel.handleChangeSearch(v);
                }}
                onBlur={() => {
                  setTimeout(() => {
                    setSearching(false);
                  }, 150);
                }}
                value={searchQuery}
              />
              {(noResults || loading) && (
                <>
                  {noResults && !searchQuery && (
                    <div style={{ textAlign: 'center', padding: '1rem' }}>
                      {lang.t(LANG_CONST.text.no_results_yet)}
                    </div>
                  )}
                  {noResults && searchQuery && (
                    <div style={{ textAlign: 'center', padding: '1rem' }}>
                      {lang.t(LANG_CONST.text.nothing_found)}
                    </div>
                  )}
                </>
              )}
            </View>
          ),
          Footer: () => (
            <div style={{ textAlign: 'center', paddingBottom: 20, flex: 1 }}>
              {loading && <Spinner />}
            </div>
          )
        }}
        endReached={() => {
          if (managersModel.hasMore() && !managersModel.refreshing()) managersModel.loadMore();
        }}
        itemContent={(index, item) => (
          <Item item={item} index={index} onManagerItem={onManagerItem} />
        )}
      />
    </View>
  );
};
